module.exports = __webpack_public_path__ + "img/组 498@2x.667e3c90.png";